import { computed, Signal } from '@angular/core';
import { CompanySessionService } from '@core/auth/company-session.service';
import { OnboardingProgressService } from '@features/recruitment/dashboard/onboarding/onboarding-progress.service';
import { environment } from '@env';

export function createSidebarVisibilityMap(session: CompanySessionService, progress: OnboardingProgressService) {
  const hasCompany = computed(() => session.memberships().length > 0 || environment.isDev);
  return {
    hasCompany,
    companyVerified: computed(() => !!session.activeCompanyDetails()?.verifiedAt),
    // The dashboard is a getting-started surface: only offer it while there is a
    // company and onboarding is still incomplete.
    dashboardVisible: computed(() => hasCompany() && !progress.isComplete()),
  } satisfies Record<string, Signal<boolean>>;
}

export type SidebarVisibilityKey = keyof ReturnType<typeof createSidebarVisibilityMap>;
